// extracted by mini-css-extract-plugin
export default {"container":"consent_container__5xK73"};